export default "__VITE_ASSET__D8ZuCF6U__"